<script>
import { mapActions, mapState } from 'vuex'
import utils from '@/utils'
import _ from 'lodash'
import vueMarkdown from 'vue-markdown'

const commonRules = {
  'required-field': {
    required: true,
    message: 'To pole jest wymagane.',
    trigger: 'blur'
  }
}

export default {
  name: 'in-touch',
  data () {
    var validateApi = (rule, value, callback, source, options) => {
      if (this.errors[ rule.field ]) {
        this.errors[ rule.field ].forEach(function (message) {
          callback(message)
        })
        delete this.errors[ rule.field ]
      } else {
        callback()
      }
    }

    return {
      message: {},
      errors: [],
      formChanged: false,
      rules: {
        content: [
          commonRules[ 'required-field' ],
          { validator: validateApi, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.aFetchCartMessages()
  },
  updated () {
    this.formChanged = true
  },
  components: {
    'markdown': vueMarkdown
  },
  computed: {
    ...mapState([ 'cartMessages' ]),
    messages () {
      this.cartMessages.forEach((message) => {
        message.teaser = _.truncate(message.content, { length: 250, separator: /\S+\s*/g })
      })
      return this.cartMessages
    }
  },
  methods: {
    ...mapActions([ 'aCartMessageCreate', 'aFetchCartMessages' ]),
    handleSubmitMessage () {
      this.$refs.message.validate((valid) => {
        if (valid) {
          this.aCartMessageCreate(this.message)
            .then(() => {
              this.aFetchCartMessages()
              this.message = {}
            })
            .catch((err) => {
              this.errors = utils.keysToCamel(err.body)
              this.$refs.message.validate()
              return false
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<template>
  <el-main>
    <el-row class="message-form">
      <el-form
        ref="message"
        size="small"
        :model="message"
        :rules="rules"
      >
        <el-form-item label="Nowa wiadomość">
          <el-input
            size="mini"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 16 }"
            placeholder="Napisz do nas..."
            v-model="message.content"
          >
          </el-input>
        </el-form-item>
        <el-form-item align="right">
          <el-button
            size="mini"
            type="primary"
            @click="handleSubmitMessage()"
          >Wyślij wiadomość</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row class="messages-wrapper">
      <el-table
        :data="messages"
        :show-header="false"
        empty-text="Nie ma jeszcze żadnych wiadomości."
        size="mini"
        class="messages"
        style="width: 100%"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <markdown>{{ props.row.content }}</markdown>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="props">
            <h3>
              {{ props.row.sender_name }}
              <span class="annotation">{{ props.row.created | format_datetime('dddd, D MMM YYYY, HH:mm') }}</span>
            </h3>
            <p class="teaser">{{ props.row.teaser }}</p>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </el-main>
</template>



// WEBPACK FOOTER //
// src/components/cart-messages.vue